// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4468":"0c2054aa","9625":"0c2054aa"}[chunkId] + ".chunk.css";
};